export default "__VITE_ASSET__CNi2YA7a__"